import { Checkbox, Popover, Radio, Switch } from 'antd';
import { FieldKeys } from '../../../../common/api/services/HistoryApi/types/fieldKeys';
import { getError } from '../../../../common/api/utils/getError';
import CommonDatePicker from '../../../../components/date-picker/CommonDatePicker';
import Dropdown from '../../../../components/dropdown/Dropdown';
import Input from '../../../../components/input/Input';
import {
    changeActiveField,
    changeHistoryField,
    removeActiveFile,
    removeHistoryFile,
} from '../../../../redux/reducers/onboarding-history/sliceReducer';
import { ShownTypes } from '../../../../redux/reducers/onboarding-history/types';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import CrossIcon from '../../../../assets/icons/CrossIcon';
import { createMask } from '../../../../common/utils/inputMaskUtils';
import UploadDropzone from '../../../../components/upload-dropzone/UploadDropzone';
import { fileApi } from '../../../../common/api/services/FileApi/FileApi';
import { UploadEntity, UploadEntityId } from '../../../../common/api/services/FileApi/enums/RequestEnums';
import { openErrorNotification } from '../../../../components/notification/Notification';
import { IHistoryItem } from '../../../../common/api/services/HistoryApi/types/historyTypes';
import WarningIcon from '../../../../assets/icons/WarningIcon';

import { useParams } from 'react-router-dom';

import {
    changeActiveFieldCompany,
    changeHistoryFieldCompany,
} from '../../../../redux/reducers/onboarding-history-WC/sliceReducer';
import { ROUTER_PATHS } from '../../../../navigation/routerPaths';
import { useLocation } from 'react-router-dom';
import { IBankAccount } from '../../../../common/api/services/SystemInfoApi/types/ISystemInfo';
import { useState } from 'react';

const { workContract } = ROUTER_PATHS;

interface IProps {
    fieldKey: FieldKeys;
    field?: IHistoryItem;
    isActiveField?: boolean;
    value: any;
    //showAsterick
    showAsterick?: boolean;
    index: number;
    companyId?: string;
    isView?: boolean;
}

const HistoryField = (props: IProps) => {
    const { fieldKey, field, isActiveField, value, index, companyId, isView } = props;
    const pathName = useLocation().pathname;
    const isWCPage = pathName.includes(workContract);
    const historyWC = useAppSelector((state) => state.onBoardingHistoryWC.historyFields);
    const isWorkContractField = fieldKey === FieldKeys.invoiceCurrency || fieldKey === FieldKeys.workTimeContract;
    const historyOnboarding = useAppSelector((state) => state.onBoardingHistory.historyFields);
    const { bankAccounts } = useAppSelector((state) => state.onboarding);
    const [fileList, setFileList] = useState(value || []);

    const historyFields = isWorkContractField ? historyWC : historyOnboarding;

    const activeFieldsOnboarding = useAppSelector((state) => state.onBoardingHistory.activeFields);

    const activeFieldsWC = useAppSelector((state) => state.onBoardingHistoryWC.activeFields);

    const activeFields = isWorkContractField ? activeFieldsWC : activeFieldsOnboarding;
    const errorMessages = useAppSelector((state) => state.onBoardingHistory.errorMessages);
    const dispatch = useAppDispatch();
    const onChangeInput = (unputValue: any) => {
        if (field?.key === 'maritalStatusDetails.spouseSSN') {
            return createMask(unputValue, value?.toString());
        }
        if (field?.key === 'iban') {
            return unputValue.replace(/\s+/g, '').replace(/[^a-zA-Z0-9]/g, '');
        }
        return unputValue;
    };
    const authState = useAppSelector((state) => state.auth);
    const { consultantId } = useParams(); // TODO: probably should be taken fron state not params in case of timesheet, expenses, etc.

    const isDisabled =
        isView ||
        (field?.disabled
            ? field?.disabled(
                  (isActiveField ? activeFields[fieldKey]?.[index] : historyFields[fieldKey]?.[index]) || {}
              )
            : false);

    const onChange = (e: any) => {
        if (isActiveField) {
            dispatch(
                isWorkContractField
                    ? changeActiveFieldCompany({
                          fieldKey,
                          index,
                          value: field?.inputType === 'number' ? +e.target.value : onChangeInput(e.target.value),
                          changedField: field?.key as string,
                          companyId,
                      })
                    : changeActiveField({
                          fieldKey,
                          index,
                          value: field?.inputType === 'number' ? +e.target.value : onChangeInput(e.target.value),
                          changedField: field?.key as string,
                          companyId,
                      })
            );
        } else {
            dispatch(
                isWorkContractField
                    ? changeHistoryFieldCompany({
                          fieldKey,
                          index,
                          value: field?.inputType === 'number' ? +e.target.value : onChangeInput(e.target.value),
                          changedField: field?.key as string,
                          companyId,
                      })
                    : changeHistoryField({
                          fieldKey,
                          index,
                          value: field?.inputType === 'number' ? +e.target.value : onChangeInput(e.target.value),
                          changedField: field?.key as string,
                          companyId,
                      })
            );
        }
    };

    const changeDate = (key: string, date: Date | null) => {
        if (isActiveField) {
            dispatch(
                isWorkContractField
                    ? changeActiveFieldCompany({
                          fieldKey,
                          index,
                          value: date?.toDateString() ?? '',
                          changedField: field?.key as string,
                          companyId,
                      })
                    : changeActiveField({
                          fieldKey,
                          index,
                          value: date?.toDateString() ?? '',
                          changedField: field?.key as string,
                          companyId,
                      })
            );
        } else {
            dispatch(
                isWorkContractField
                    ? changeHistoryFieldCompany({
                          fieldKey,
                          index,
                          value: date?.toDateString() ?? '',
                          changedField: field?.key as string,
                          companyId,
                      })
                    : changeHistoryField({
                          fieldKey,
                          index,
                          value: date?.toDateString() ?? '',
                          changedField: field?.key as string,
                          companyId,
                      })
            );
        }
    };

    const onChangeDropdown = (key: string, value: string | boolean) => {
        if (isActiveField) {
            dispatch(
                isWorkContractField
                    ? changeActiveFieldCompany({
                          fieldKey,
                          index,
                          value,
                          changedField: field?.key as string,
                          companyId,
                      })
                    : changeActiveField({
                          fieldKey,
                          index,
                          value,
                          changedField: field?.key as string,
                          companyId,
                      })
            );
        } else {
            dispatch(
                isWorkContractField
                    ? changeHistoryFieldCompany({
                          fieldKey,
                          index,
                          value,
                          changedField: field?.key as string,
                          companyId,
                      })
                    : changeHistoryField({
                          fieldKey,
                          index,
                          value,
                          changedField: field?.key as string,
                          companyId,
                      })
            );
        }
    };

    const onChangeChecked = (event: any) => {
        if (isActiveField) {
            dispatch(
                isWorkContractField
                    ? changeActiveFieldCompany({
                          fieldKey,
                          index,
                          value: event.target.checked,
                          changedField: field?.key as string,
                          companyId,
                      })
                    : changeActiveField({
                          fieldKey,
                          index,
                          value: event.target.checked,
                          changedField: field?.key as string,
                          companyId,
                      })
            );
        } else {
            dispatch(
                isWorkContractField
                    ? changeHistoryFieldCompany({
                          fieldKey,
                          index,
                          value: event.target.checked,
                          changedField: field?.key as string,
                          companyId,
                      })
                    : changeHistoryField({
                          fieldKey,
                          index,
                          value: event.target.checked,
                          changedField: field?.key as string,
                          companyId,
                      })
            );
        }
    };

    const onSubmitFile = (files: any) => {
        fileApi
            .uploadFile(
                files,
                fieldKey === 'maritalStatus'
                    ? UploadEntityId.spouseWorkPermitDocuments
                    : UploadEntityId.workPermitHistory,
                UploadEntity.consultantOnboarding,
                consultantId ? consultantId : authState._id
            )
            .then((response: any) => {
                setFileList((prevFiles: any) => {
                    const newFiles = [...response, ...prevFiles];

                    if (isActiveField) {
                        dispatch(
                            isWorkContractField
                                ? changeActiveFieldCompany({
                                      fieldKey,
                                      index,
                                      value: newFiles,
                                      changedField: field?.key as string,
                                      companyId,
                                  })
                                : changeActiveField({
                                      fieldKey,
                                      index,
                                      value: newFiles,
                                      changedField: field?.key as string,
                                      companyId,
                                  })
                        );
                    } else {
                        dispatch(
                            isWorkContractField
                                ? changeHistoryFieldCompany({
                                      fieldKey,
                                      index,
                                      value: newFiles,
                                      changedField: field?.key as string,
                                      companyId,
                                  })
                                : changeHistoryField({
                                      fieldKey,
                                      index,
                                      value: newFiles,
                                      changedField: field?.key as string,
                                      companyId,
                                  })
                        );
                    }

                    return newFiles;
                });
            })
            .catch((e) => openErrorNotification('Failed to upload file'));
    };

    const onRemoveFile = (file: any, fileId?: string) => {
        setFileList((prev: any) => prev.filter((item: any) => item.fileId !== fileId));
        if (isActiveField) {
            dispatch(
                removeActiveFile({
                    fieldKey,
                    index,
                    value: file,
                    changedField: field?.key as string,
                })
            );
        } else {
            dispatch(
                removeHistoryFile({
                    fieldKey,
                    index,
                    value: file,
                    changedField: field?.key as string,
                })
            );
        }
    };
    //TODO: fix for bank account. Not working in ininial field
    let options = field?.optionsCondition
        ? field.optionsCondition(
              (isActiveField
                  ? activeFields[fieldKey].filter((item: any) => item.companyId === companyId)[index]
                  : historyFields[fieldKey].filter((item: any) => item.companyId === companyId)[index]) || {}
          )
        : field?.options;

    if (field?.key === 'bankAccount') {
        options = bankAccounts.map((item: IBankAccount) => {
            return {
                value: item._id,
                label: `${item.name} (${item.currency})`,
            };
        });
    }

    const getIndex = () => {
        const concatArray = [...activeFieldsWC[fieldKey], ...historyWC[fieldKey]];
        let companyCount = 0;

        for (let i = 0; i < concatArray.length; i++) {
            if (concatArray[i].companyId === companyId) {
                if (companyCount === index) {
                    return i;
                }
                companyCount++;
            }
        }

        return -1;
    };

    const getErrorPathWC = () => {
        return getError(
            `histories.${fieldKey}[${
                isActiveField
                    ? getIndex()
                    : getIndex() + +activeFieldsWC[fieldKey].filter((item) => item.companyId === companyId).length
            }].${field?.key}`,
            errorMessages
        );
    };
    const errorPath = isWCPage
        ? getErrorPathWC()
        : getError(
              `histories.${fieldKey}[${isActiveField ? index : index + +activeFields[fieldKey].length}].${field?.key}`,
              errorMessages
          );

    if (field?.type === ShownTypes.input) {
        return (
            <Input
                name={field.key}
                value={value?.toString()}
                onChange={onChange}
                label={field.label}
                errorMessage={errorPath}
                inputType={field?.inputType || 'text'}
                placeholder={field?.placeholder || ''}
                disabled={isDisabled}
                className="onboarding-history-input"
            />
        );
    }

    if (field?.type === ShownTypes.date) {
        return (
            <div style={{ height: '54px' }}>
                <CommonDatePicker
                    label={field.label}
                    defaultValue={value?.toString()}
                    changeDate={(date) => changeDate(field.key, date)}
                    className="date-picker-form onboarding-history-input-picker"
                    errorMessage={errorPath}
                    bodyContainer
                    disabled={isDisabled}
                />
            </div>
        );
    }
    if (field?.type === ShownTypes.select) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <Dropdown
                    options={options}
                    label={field.label}
                    value={value?.toString()}
                    onChange={(value) => onChangeDropdown(field.key, value)}
                    errorMessage={errorPath}
                    isSearch={true}
                    allowClear
                    onClear={() => onChangeDropdown(field.key, '')}
                    disabled={isDisabled}
                    customClassName="onboarding-history-input-select"
                />
                {field?.popoverText && (
                    <Popover
                        className="info-pop-button"
                        placement="rightTop"
                        content={<p>{field?.popoverText}</p>}
                        trigger="hover"
                        overlayClassName="info-pop-content"
                        showArrow={false}
                    >
                        <button>
                            <WarningIcon />
                        </button>
                    </Popover>
                )}
            </div>
        );
    }
    if (field?.type === ShownTypes.checkbox) {
        return (
            <Checkbox
                name={field.key}
                checked={!!value}
                onChange={onChangeChecked}
                style={{ marginLeft: '10px' }}
                disabled={isDisabled}
            >
                {field.label}
            </Checkbox>
        );
    }
    if (field?.type === ShownTypes.radio) {
        return (
            //TODO: className
            <div>
                <div
                    className="onboarding-radio"
                    style={{
                        justifyContent: field?.popoverText || field.isSeporateRadio ? 'space-between' : 'flex-start',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <span>{field.label}</span>
                        {field?.popoverText && (
                            <Popover
                                className="info-pop-button"
                                placement="rightTop"
                                content={<p>{field?.popoverText}</p>}
                                trigger="hover"
                                overlayClassName="info-pop-content"
                                showArrow={false}
                            >
                                <button>
                                    <WarningIcon />
                                </button>
                            </Popover>
                        )}
                    </div>
                    <Radio.Group name={field.key} value={value} onChange={onChange} disabled={isDisabled}>
                        <Radio value={true}>Yes</Radio>
                        <Radio value={false}>No</Radio>
                    </Radio.Group>
                </div>
                {errorPath && (
                    <span className="error-message error-text">
                        <div className="icon-wrapper">
                            <CrossIcon />
                        </div>
                        {errorPath}
                    </span>
                )}
            </div>
        );
    }
    if (field?.type === ShownTypes.switch) {
        return (
            <div className="onboarding-radio">
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                        marginLeft: '10px',
                    }}
                >
                    <span>{field.label}</span>
                    <Switch
                        defaultChecked={!!value}
                        onChange={(value) => onChangeDropdown(field?.key, value)}
                        disabled={isDisabled}
                    />
                </div>
                {errorPath && (
                    <span className="error-message error-text">
                        <div className="icon-wrapper">
                            <CrossIcon />
                        </div>
                        {errorPath}
                    </span>
                )}
            </div>
        );
    }
    if (field?.type === ShownTypes.label) {
        return (
            <div
                style={{
                    gap: '15px',
                    marginLeft: '10px',
                }}
            >
                <h4>{field.label}</h4>
            </div>
        );
    }

    if (field?.type === ShownTypes.uploadFile) {
        return (
            <UploadDropzone
                defaultFiles={fileList as any}
                onSubmit={(files) => onSubmitFile(files)}
                removeFile={(file, fileId) => {
                    if (!isDisabled) {
                        onRemoveFile(file, fileId);
                    }
                }}
                isDownload
                style={{ backgroundColor: 'white' }}
                disabled={isDisabled}
            />
        );
    }

    return (
        <div>
            <span>item</span>
        </div>
    );
};

export default HistoryField;
